<template lang="pug">
  div.full-width.mt-n12
    div.d-flex.flex-grow
      v-row.header-filter
        v-col(sm=3)
          div.media-date-picker.mt-4
            DateRangePicker(
              :placeholder="$t('table.log.date')",
              :value.sync="dates",
              @update:value="fetch",
            )
        v-col(sm=3)
          v-select(
            clearable,
            required,
            hide-details,
            v-model="shop_id",
            item-text="name",
            item-value="id",
            :items="shops"
            :label="$t('table.log.shop')",
            @input="fetch",
          )
            template(v-slot:selection="{ item }")
              div {{ item.name }}
        v-col(sm=3, v-if="isSuperadmin")
          v-select(
            clearable,
            hide-details,
            v-model="staff_id",
            item-text="full_name",
            item-value="id",
            :items="staffOptions"
            :label="$t('table.log.staff')",
            @input="fetch",
          )
        v-col(fluid)
          v-spacer
        v-col(sm=2)
          LimitPicker(
            :value.sync="limit",
            @update:value="fetch",
          )
    v-card.mt-2.full-width(width="100")
      LogTable(
        ref="LogTable",
        :dates="dates",
        :limit="limit",
        :shopId="shop_id",
        :params="params",
      )

</template>

<script>
import { mapGetters } from 'vuex';
import { progressWrapper, roleManager } from '@/config/mixins.js';
import { subDurationFromToday } from '@/utils/time';

import DateRangePicker from '@/components/forms/inputs/DateRangePicker.vue';
import LimitPicker from '@/components/table/LimitPicker.vue';
import LogTable from '@/components/table/LogTable.vue';

export default {
  components: {
    DateRangePicker,
    LimitPicker,
    LogTable,
  },

  mixins: [progressWrapper, roleManager],
  data: () => ({
    limit: 10,
    dates: [subDurationFromToday({ days: 10 }), new Date()],
    shop_id: null,
    staff_id: null,
  }),

  computed: {
    ...mapGetters({
      shops: 'shop/items',
      staff: 'user/items',
    }),

    staffOptions() {
      return this.staff.filter(user => ['staff', 'superadmin'].includes(user.role));
    },

    params() {
      return this.staff_id ? { type: 'creator', type_id: this.staff_id } : {};
    },
  },

  created() {
    this.wrapProgress(() => {
      this.$store.dispatch('shop/fetch', {});

      // Non-superadmin staff can't list other staff accounts server-side
      // (by design, see db/model/User/index.js fetch()) - skip the call
      // entirely rather than fetch something the API will silently filter
      // down to customers only, which would pollute user/items for
      // anything else on the page relying on it.
      if (this.isSuperadmin) {
        this.$store.dispatch('user/fetch', {
          role: ['staff', 'superadmin'],
          limit: 1000,
          hardFetch: true,
        });
      }
    });
  },

  methods: {
    fetch() {
      this.$nextTick(() => {
        this.$refs.LogTable.fetch(true);
      });
    },
  },
};
</script>
